import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "cursor" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M17.8043 14.8565H13.6603L15.8412 20.1687C15.9932 20.537 15.8196 20.9499 15.4723 21.1062L13.5518 21.9431C13.1938 22.0994 12.7923 21.9208 12.6404 21.5637L10.568 16.5193L7.18273 20.0013C6.7316 20.4652 6 20.1076 6 19.4991V2.71479C6 2.07417 6.77816 1.76187 7.18269 2.21261L18.2925 13.64C18.7407 14.0767 18.41 14.8565 17.8043 14.8565V14.8565Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }